import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, vModelText as _vModelText, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69d63a20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__cnt-license" }
const _hoisted_2 = {
  key: 0,
  class: "license__not-logged-in"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "license__option" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Bitte auswählen:", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "license__option" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: ""
}, "Bitte auswählen", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Aus- und Weiterbildungsstätte", -1))
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "license__option" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Bitte auswählen:", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["disabled", "value"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "nicht verfügbar", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "license__input-container"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Für welche Ärztin in Weiterbildung / welchen MFA-Azubi soll die Lizenz verwendet werden?", -1))
const _hoisted_27 = { class: "trainee-field" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "trainee_email" }, "E-Mail-Adresse der ÄiW / des MFA-Azubi", -1))
const _hoisted_29 = { class: "trainee-field" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "trainee_first_name" }, "Vorname der ÄiW / des MFA-Azubi", -1))
const _hoisted_31 = { class: "trainee-field" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "trainee_last_name" }, "Nachname der ÄiW / des MFA-Azubi", -1))
const _hoisted_33 = {
  key: 2,
  class: "license__select-start-date license__input-container"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Wählen Sie den gewünschten Startzeitpunkt der Lizenz aus", -1))
const _hoisted_35 = { class: "license__input-wrapper" }
const _hoisted_36 = {
  key: 3,
  class: "license__select-amount license__input-container"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Wählen Sie die gewünschte Laufzeit der Lizenz aus", -1))
const _hoisted_38 = { class: "license__input-wrapper" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["value"]
const _hoisted_41 = {
  key: 4,
  class: "license__confirmation"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Zusammenfassung", -1))
const _hoisted_43 = { class: "license__input-container license__input-container--no-top-margin license__input-container--with-bottom-margin" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Anmerkungen zur Buchung", -1))
const _hoisted_45 = { class: "license__input-wrapper" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { key: 0 }

import { computed, ref, watch } from 'vue';
  import { parseISO, add, format } from "date-fns";
  import { useStore } from 'vuex';

  import { cntProps } from 'vue/applications/frontend/mixins/cnt-component';
  import HttpMethod from 'vue/applications/shared/endpoints/utils/http-method';
  import UniversalEndpoint from '../../endpoints/universal-endpoint';
  import SimpleDatepicker from 'vue/applications/frontend/components/simple-datepicker.vue'
 
  
export default /*#__PURE__*/_defineComponent({
  __name: 'cnt-license',
  props: {...cntProps()},
  setup(__props) {

  const props = __props;

  const store = useStore();
  const backendData = ref({
    selectedPractice: null,
    selectedCurriculumId: null,
    selectedLicenseClass: null,
    selectedStartAt: null,
    selectedAmount: null,
    comment: "",
    trainee_email: null,
    trainee_first_name: null,
    trainee_last_name: null,
  });
  const sending = ref<boolean>(false);
  const errors = ref<Array<any>>([]);
  const role_type = ref<String | null>(null);

  const availableLicensesForCurriculum = computed(() => {
    if(!backendData.value.selectedCurriculumId) return props.contentItem.widget_data.available_licenses;

    return props.contentItem.widget_data.available_licenses.filter((license: any) => {
      return license.curriculum_id == backendData.value.selectedCurriculumId
    });
  });

  const selectedRole = computed(() => {
    if (
      !props.contentItem ||
      !props.contentItem.widget_data ||
      !props.contentItem.widget_data.roles
    )
      return null;

    return props.contentItem.widget_data.roles.find((role: any) => role.id == role_type.value);
  });

  const selectedLicense = computed(() => {
    if (
      !props.contentItem ||
      !props.contentItem.widget_data ||
      !props.contentItem.widget_data.available_licenses
    )
      return null;

    for (const license of props.contentItem.widget_data.available_licenses) {
      if (license.license_class === backendData.value.selectedLicenseClass) {
        return license;
      }
    }
    return null;
  });

  const selectedCurriculum = computed(() => {
    if (
      !props.contentItem ||
      !props.contentItem.widget_data ||
      !props.contentItem.widget_data.available_curricula
    )
      return null;

    for (const curriculum of props.contentItem.widget_data.available_curricula) {
      if (curriculum.id === backendData.value.selectedCurriculumId) {
        return curriculum;
      }
    }
    return null;
  });

  const needSelectStartDate = computed(() => true);
  const showSelectStartDate = computed(() => needSelectStartDate.value && selectedLicense.value)
  const needSelectAmount = computed(() => selectedLicense.value?.booking_options?.length > 1);
  
  const showSelectAmount = computed(() => (needSelectAmount.value && selectedLicense.value &&
    (!needSelectStartDate.value || backendData.value.selectedStartAt)));
  
  const effectiveSelectedAmount = computed(() => {
    if (backendData.value.selectedAmount) {
      for (const bookingOption of selectedLicense.value.booking_options) {
        if (bookingOption.id === backendData.value.selectedAmount) {
          return bookingOption;
        }
      }
      console.error("No booking option found. This should not happen");
      return null;
    } else if (selectedLicense.value.booking_options.length == 1) {
      return selectedLicense.value.booking_options[0];
    } else {
      return null;
    }
  });

  const showConfirmation = computed(() => (
    selectedLicense.value && backendData.value.trainee_email && backendData.value.trainee_first_name && backendData.value.trainee_last_name &&
    (!needSelectStartDate.value || backendData.value.selectedStartAt) &&
    (!needSelectAmount.value || backendData.value.selectedAmount)));

  // returns the end date, null indicates no end date (i.e. unlimited period of validity)
  const endDate = computed(() => {
    if (
      !backendData.value.selectedStartAt ||
      !selectedLicense.value ||
      !effectiveSelectedAmount.value
    )
      return null;

    if (effectiveSelectedAmount.value.duration.unit == "unlimited") {
      return null;
    }

    const adder: Record<string, number> = {};
    adder[
      effectiveSelectedAmount.value.duration.unit
    ] = effectiveSelectedAmount.value.duration.amount;
    return add(parseISO(backendData.value.selectedStartAt), adder);
  });

  const translateDuration = (duration: string, amount: number) => {
    if (!amount) amount = 100;
    switch (duration) {
      case "years":
        return amount > 1 ? "Jahre" : "Jahr";
      case "months":
        return amount > 1 ? "Monate" : "Monat";
      case "weeks":
        return amount > 1 ? "Wochen" : "Woche";
      default:
        return duration;
    }
  };
  const formatISODate = (dateStr: string) => {
    if (!dateStr) return "unbekannt";
    return formatDate(parseISO(dateStr));
  };
  const formatDate = (date: Date) => {
    if (!date) return "unbekannt";
    return format(date, "dd.MM.yyyy");
  };
  const formatPrice = (price: number) => {
    if (price !== 0 && !price) return "-";

    const cents = price % 100;
    const paddedCents = `${cents}00`.substring(0, 2);

    const euros = (price - cents) / 100;

    return `${euros},${paddedCents}`;
  };
  const onBookLicense = async() => {
    if (sending.value) return;

    let skipSendingFlip = false;

    try {
      sending.value = true;
      errors.value = [];

      const endpoint = new UniversalEndpoint(store);
      const response = await endpoint.request(
        props.contentItem.widget_data.license_booking_user_path,
        HttpMethod.POST,
        { selectedPractice: backendData.value.selectedPractice ?? undefined,
          selectedCurriculumId: backendData.value.selectedCurriculumId ?? undefined,
          selectedLicenseClass:  backendData.value.selectedLicenseClass ?? undefined,
          selectedStartAt:  backendData.value.selectedStartAt ?? undefined,
          selectedAmount:  backendData.value.selectedAmount ?? undefined,
          comment: backendData.value.comment ?? '',
          trainee_email: backendData.value.trainee_email ?? undefined,
          trainee_first_name: backendData.value.trainee_first_name ?? undefined,
          trainee_last_name: backendData.value.trainee_last_name ?? undefined,
        },
      );

      if (response && response.data) {
        if (response.data.redirect) {
          location.href = response.data.redirect;
          skipSendingFlip = true;
        } else {
          const errMessage = response.data.error ?? `Es ist etwas schief gelaufen. Bitte versuchen Sie es erneut. Falls der Fehler wiederholt auftritt, wenden Sie sich bitte an ${props.contentItem.widget_data.support_mail}`;
          errors.value.push(errMessage);
        }
      }
    } finally {
      sending.value = skipSendingFlip;
    }
  };

  watch(selectedLicense, () => {
    backendData.value.selectedAmount = null;
  });

  watch(() => backendData.value.selectedCurriculumId, () => {
    backendData.value.selectedLicenseClass = null;
  });

  watch(
    () => props.contentItem.widget_data.available_curricula,
    (availableCurricula: any) => {
      if (availableCurricula.length === 1) {
        backendData.value.selectedCurriculumId = availableCurricula[0].id;
      }
    },
    { immediate: true }
    );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.contentItem)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.contentItem.widget_data.login_path)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createTextVNode(" Sie müssen sich zunächst "),
                _createElementVNode("a", {
                  href: _ctx.contentItem.widget_data.login_path
                }, "einloggen oder registrieren", 8, _hoisted_3),
                _createTextVNode(", um die Bestellung einer Lizenz durchführen zu können. ")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_5, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((role_type).value = $event))
                    }, [
                      _hoisted_6,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentItem.widget_data.roles, (role) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: role.id,
                          value: role.id
                        }, _toDisplayString(role.label), 9, _hoisted_7))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, role_type.value]
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("strong", null, [
                        (role_type.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(selectedRole.value.label), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("Ich möchte " + _toDisplayString(_ctx.contentItem.widget_data.app_flavor_name) + " nutzen als", 1)
                            ], 64))
                      ])
                    ])
                  ])
                ]),
                (role_type.value == 'trainee')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Die Lizenzbestellung wird von Ihrer/Ihrem Weiterbildungsberechtigten vorgenommen. Bis zur Genehmigung der Lizenz können Sie kostenfrei die Schnupperversion verwenden."))
                  : (role_type.value != null)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_9, [
                            (_ctx.contentItem.widget_data.available_practices.length > 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((backendData.value.selectedPractice) = $event))
                                  }, [
                                    _hoisted_10,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentItem.widget_data.available_practices, (practice) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: practice,
                                        value: practice
                                      }, _toDisplayString(practice), 9, _hoisted_11))
                                    }), 128))
                                  ], 512), [
                                    [_vModelSelect, backendData.value.selectedPractice]
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("strong", null, [
                                      (backendData.value.selectedPractice)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(_toDisplayString(backendData.value.selectedPractice), 1)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode("Aus- und Weiterbildungsstätte")
                                          ], 64))
                                    ])
                                  ])
                                ], 64))
                              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _hoisted_13,
                                  _createElementVNode("div", null, [
                                    _createElementVNode("a", {
                                      href: _ctx.contentItem.widget_data.practice_data_path
                                    }, "Bitte geben Sie hier zunächst die Daten Ihrer Aus- und Weiterbildungsstätte an.", 8, _hoisted_14)
                                  ])
                                ]))
                          ])
                        ]),
                        (backendData.value.selectedPractice)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("label", _hoisted_15, [
                                  (_ctx.contentItem.widget_data.available_curricula.length > 1)
                                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                        key: 0,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((backendData.value.selectedCurriculumId) = $event))
                                      }, [
                                        _hoisted_16,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentItem.widget_data.available_curricula, (curriculum) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: curriculum.id,
                                            value: curriculum.id
                                          }, _toDisplayString(curriculum.name), 9, _hoisted_17))
                                        }), 128))
                                      ], 512)), [
                                        [_vModelSelect, backendData.value.selectedCurriculumId]
                                      ])
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("strong", null, [
                                      (selectedCurriculum.value)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(_toDisplayString(selectedCurriculum.value.name), 1)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode("Curriculum")
                                          ], 64))
                                    ]),
                                    (selectedCurriculum.value && selectedCurriculum.value.short_description)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(selectedCurriculum.value.short_description), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]),
                              (backendData.value.selectedCurriculumId)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (availableLicensesForCurriculum.value.length <= 0)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, " Aktuell steht keine Lizenz für das Curriculum zur Verfügung. "))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableLicensesForCurriculum.value, (license) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: license.license_class
                                      }, [
                                        _createElementVNode("label", {
                                          class: _normalizeClass(["license__option", {
                    'license__option--disabled': license.disabled,
                    'license__option--selected': license === selectedLicense.value,
                  }])
                                        }, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "radio",
                                            disabled: license.disabled || sending.value,
                                            value: license.license_class,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((backendData.value.selectedLicenseClass) = $event))
                                          }, null, 8, _hoisted_20), [
                                            [_vModelRadio, backendData.value.selectedLicenseClass]
                                          ]),
                                          _createElementVNode("div", null, [
                                            _createElementVNode("strong", null, _toDisplayString(license.title), 1),
                                            (license.description)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(license.description), 1))
                                              : _createCommentVNode("", true),
                                            (license.disabled)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
                                              : _createCommentVNode("", true)
                                          ])
                                        ], 2)
                                      ]))
                                    }), 128)),
                                    (selectedLicense.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                          _createElementVNode("label", null, [
                                            _hoisted_26,
                                            _createElementVNode("div", _hoisted_27, [
                                              _hoisted_28,
                                              _withDirectives(_createElementVNode("input", {
                                                type: "email",
                                                id: "trainee_email",
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((backendData.value.trainee_email) = $event)),
                                                placeholder: "E-Mail-Adresse",
                                                required: ""
                                              }, null, 512), [
                                                [_vModelText, backendData.value.trainee_email]
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_29, [
                                              _hoisted_30,
                                              _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                id: "trainee_first_name",
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((backendData.value.trainee_first_name) = $event)),
                                                placeholder: "Vorname",
                                                required: ""
                                              }, null, 512), [
                                                [_vModelText, backendData.value.trainee_first_name]
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_31, [
                                              _hoisted_32,
                                              _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                id: "trainee_last_name",
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((backendData.value.trainee_last_name) = $event)),
                                                placeholder: "Nachname",
                                                required: ""
                                              }, null, 512), [
                                                [_vModelText, backendData.value.trainee_last_name]
                                              ])
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (showSelectStartDate.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                          _createElementVNode("label", null, [
                                            _hoisted_34,
                                            _createElementVNode("div", _hoisted_35, [
                                              _createVNode(SimpleDatepicker, {
                                                future: "",
                                                "min-date": new Date(),
                                                modelValue: backendData.value.selectedStartAt,
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((backendData.value.selectedStartAt) = $event)),
                                                "skip-default-value": "",
                                                disabled: sending.value
                                              }, null, 8, ["min-date", "modelValue", "disabled"])
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (showSelectAmount.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                          _createElementVNode("label", null, [
                                            _hoisted_37,
                                            _createElementVNode("div", _hoisted_38, [
                                              _withDirectives(_createElementVNode("select", {
                                                disabled: sending.value,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((backendData.value.selectedAmount) = $event))
                                              }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedLicense.value.booking_options, (bookingOption) => {
                                                  return (_openBlock(), _createElementBlock("option", {
                                                    key: bookingOption.id,
                                                    value: bookingOption.id
                                                  }, _toDisplayString(bookingOption.duration.amount) + " " + _toDisplayString(translateDuration(
                            bookingOption.duration.unit,
                            bookingOption.duration.amount,
                          )), 9, _hoisted_40))
                                                }), 128))
                                              ], 8, _hoisted_39), [
                                                [_vModelSelect, backendData.value.selectedAmount]
                                              ])
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (showConfirmation.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                          _hoisted_42,
                                          _createElementVNode("div", _hoisted_43, [
                                            _createElementVNode("label", null, [
                                              _hoisted_44,
                                              _createElementVNode("div", _hoisted_45, [
                                                _withDirectives(_createElementVNode("textarea", {
                                                  rows: "5",
                                                  disabled: sending.value,
                                                  placeholder: "Anmerkungen...",
                                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((backendData.value.comment) = $event))
                                                }, null, 8, _hoisted_46), [
                                                  [_vModelText, backendData.value.comment]
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("p", null, [
                                            _createTextVNode(" Ich möchte die Option "),
                                            _createElementVNode("strong", null, "„" + _toDisplayString(selectedLicense.value.title) + "“", 1),
                                            _createTextVNode(" ab dem "),
                                            _createElementVNode("strong", null, _toDisplayString(formatISODate(backendData.value.selectedStartAt)), 1),
                                            (endDate.value)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(" bis zum "),
                                                  _createElementVNode("strong", null, _toDisplayString(formatDate(endDate.value)), 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            (effectiveSelectedAmount.value.price > 0)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                  _createTextVNode(" für einmalig "),
                                                  _createElementVNode("strong", null, _toDisplayString(formatPrice(effectiveSelectedAmount.value.price)) + " €", 1),
                                                  _createTextVNode(" (inkl. 19% MwSt.) kostenpflichtig")
                                                ], 64))
                                              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                  _createTextVNode("kostenlos")
                                                ], 64)),
                                            _createTextVNode(" bestellen. ")
                                          ]),
                                          (errors.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error, index) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: index,
                                                    class: "booking__error"
                                                  }, _toDisplayString(error), 1))
                                                }), 128))
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", null, [
                                            _createElementVNode("button", {
                                              class: _normalizeClass(["button", { 'button--disabled': sending.value }]),
                                              onClick: onBookLicense
                                            }, [
                                              (sending.value)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createTextVNode(" Bestellung wird durchgeführt... ")
                                                  ], 64))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    (effectiveSelectedAmount.value.price > 0)
                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                          _createTextVNode("Kostenpflichtig")
                                                        ], 64))
                                                      : _createCommentVNode("", true),
                                                    _createTextVNode(" bestellen")
                                                  ], 64))
                                            ], 2)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
              ]))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})